import * as React from "react";
import AccountAddForm from "../../../../forms/secure/AccountAddForm";
import StatusMessage from "../../../../presentational/StatusMessage";
import * as StatusMessages from "../../../../../constants/StatusMessages";
export default (props) => (<div>
		<StatusMessage isError isActive={props.validationError ? true : false} error={props.validationError ? props.validationError : null} customMessage={StatusMessages.VALIDATION.INTRO_ADD_ACCOUNT} domain="validation" willPersist/>
		<div className="vr vr_x9">
			<div className="formHorizontal account-add-form">
				<AccountAddForm addAccount={props.confirmAddAccount} fieldErrors={props.validationFieldErrors} openModal={props.openModal} isLoading={props.validationIsLoading} value={props.addForm} onChange={props.addFormChange} accts={props.accts}/>
			</div>
		</div>
	</div>);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Dashboard/AddAccountForm/AddAccountForm.tsx